import React, { useState } from 'react';

import { Box, Button, Stack, TextField } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';

import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, SubmitButton } from '../../../../components/mui/Buttons/Buttons';
import { assignTutor, getStudentListAndTutorList } from '../../../../redux/features/CRDslice';
const AssignTutor = ({ open, setOpen,isDisable, subjectEnrollmentId, rowDetails ,dispatchParams}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = false;
  const { enqueueSnackbar } = useSnackbar();
  const initialValues = {
    paymentPerSession: '',
    duration: '',
    noOfAttendance: '',
    TPRemarks: '',
  };

  const schema = Yup.object({
    // paymentPerSession: Yup.number().required("Payment per session is required"),
    // duration: Yup.number().required("Duration per session in minutes required"),
    // noOfAttendance: Yup.number().required(
    //   "Number of attendence per day is requird"
    // ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(values);
      const data = {
        ...values,
        mapped_project: rowDetails?.project_id,
        trainer_id: rowDetails?.trainer_id,
        subjectEnrollmentId: subjectEnrollmentId,
      };
      dispatch(assignTutor(data)).then((res) => {
        if (res.payload.status === 'error') {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
        } else if (res.payload.status === 'success') {
          dispatch(getStudentListAndTutorList(dispatchParams));
          handleCancel();
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
        }
      });
    },
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };
  return (
    <GlobalDialog
      maxWidth={'sm'}
      fullWidth
      title={'Action'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack gap={2}>
                  <Box>
                    <TextField
                      type="number"
                      autoComplete="off"
                      fullWidth
                      id="paymentPerSession"
                      label="Payment"
                      placeholder="Enter amount per session"
                      name="paymentPerSession"
                      value={formik.values.paymentPerSession}
                      onChange={formik.handleChange}
                      error={formik.touched.paymentPerSession && Boolean(formik.errors.paymentPerSession)}
                      helperText={formik.touched.paymentPerSession && formik.errors.paymentPerSession}
                    />
                  </Box>
                  <Box>
                    <TextField
                      type="number"
                      autoComplete="off"
                      fullWidth
                      id="duration"
                      label="Duration"
                      placeholder="Enter duration in minutes per session"
                      name="duration"
                      value={formik.values.duration}
                      onChange={formik.handleChange}
                      error={formik.touched.duration && Boolean(formik.errors.duration)}
                      helperText={formik.touched.duration && formik.errors.duration}
                    />
                  </Box>
                  <Box>
                    <TextField
                      type="number"
                      autoComplete="off"
                      fullWidth
                      id="noOfAttendance"
                      label="No of Attendance per day"
                      placeholder="Enter number of attendance per day"
                      name="noOfAttendance"
                      value={formik.values.noOfAttendance}
                      onChange={formik.handleChange}
                      error={formik.touched.noOfAttendance && Boolean(formik.errors.noOfAttendance)}
                      helperText={formik.touched.noOfAttendance && formik.errors.noOfAttendance}
                    />
                  </Box>
                  <Box>
                    <TextField
                      type="TEXT"
                      autoComplete="off"
                      fullWidth
                      id="TPRemarks"
                      label="TP Remarks"
                      placeholder="Enter remarks if TPR is greater than 40% of fee per session"
                      name="TPRemarks"
                      value={formik.values.TPRemarks}
                      onChange={formik.handleChange}
                      error={formik.touched.TPRemarks && Boolean(formik.errors.TPRemarks)}
                      helperText={formik.touched.TPRemarks && formik.errors.TPRemarks}
                    />
                  </Box>
                </Stack>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Stack direction={'row'} spacing={1}>
                  <CancelButton action={() => handleCancel()}>Cancel</CancelButton>

                  <SubmitButton disabled={loading} type="submit">
                    {loading ? 'Submiting...' : 'Submit'}
                  </SubmitButton>
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AssignTutor;
